import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ab378c82"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "NewCostStandardsFilters__holder" }
const _hoisted_2 = { class: "font-semibold" }
const _hoisted_3 = { class: "flex items-center gap-3" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash" }, null, -1))
const _hoisted_5 = { class: "flex items-center justify-center" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus mr-2" }, null, -1))
const _hoisted_7 = { class: "py-4 px-3 flex items-center justify-end" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-undo mr-2" }, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-search mr-2" }, null, -1))
const _hoisted_10 = { class: "NewCostStandardsFilters mt-3" }
const _hoisted_11 = { class: "NewCostStandardsFilters__holder" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_new_select = _resolveComponent("new-select")!
  const _component_new_button = _resolveComponent("new-button")!
  const _component_radio_group = _resolveComponent("radio-group")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("form", {
      class: "NewCostStandardsFilters",
      onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onFiltersChanged && _ctx.onFiltersChanged(...args)), ["prevent"]))
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_new_select, {
          "can-deselect": "",
          placeholder: "Откуда",
          value: _ctx.state.fromCityId,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.fromCityId) = $event)),
          disabled: _ctx.disabled,
          options: _ctx.data_state.cities.list,
          loading: _ctx.data_state.cities.is_loading,
          failed: _ctx.data_state.cities.is_failed,
          "is-invalid": _ctx.validation$.fromCityId.$error,
          "validation-errors": _ctx.validation$.fromCityId.$errors,
          "error-text": "При получении списка городов произошла ошибка",
          "search-without-refresh": "",
          onRefresh: _ctx.loadCities
        }, null, 8, ["value", "disabled", "options", "loading", "failed", "is-invalid", "validation-errors", "onRefresh"]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.transitCityIds, (city, i) => {
          return (_openBlock(), _createElementBlock("div", {
            key: `transit-city-${i}`,
            class: "grid grid-cols-1 gap-3"
          }, [
            _createElementVNode("div", _hoisted_2, "Транзит №" + _toDisplayString(i + 1), 1),
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_new_select, {
                "can-deselect": "",
                class: "w-full",
                value: _ctx.state.transitCityIds[i],
                "onUpdate:value": ($event: any) => ((_ctx.state.transitCityIds[i]) = $event),
                placeholder: "Выберите из списка",
                loading: _ctx.data_state.cities.is_loading,
                disabled: _ctx.data_state.cities.is_loading,
                failed: _ctx.data_state.cities.is_failed,
                options: _ctx.data_state.cities.list,
                "is-invalid": !_ctx.state.transitCityIds[i],
                "error-text": "При получении списка городов произошла ошибка",
                onRefresh: _ctx.loadCities
              }, null, 8, ["value", "onUpdate:value", "loading", "disabled", "failed", "options", "is-invalid", "onRefresh"]),
              _createVNode(_component_new_button, {
                class: "NewButton--red",
                style: { width: 'fit-content' },
                onClick: ($event: any) => (_ctx.deleteTransitCity(i))
              }, {
                default: _withCtx(() => [
                  _hoisted_4
                ]),
                _: 2
              }, 1032, ["onClick"])
            ])
          ]))
        }), 128)),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_new_button, {
            class: "NewButton--search",
            style: { width: 'fit-content' },
            onClick: _ctx.addTransitCity
          }, {
            default: _withCtx(() => [
              _hoisted_6,
              _createTextVNode(" Добавить город транзит ")
            ]),
            _: 1
          }, 8, ["onClick"])
        ]),
        _createVNode(_component_new_select, {
          "can-deselect": "",
          placeholder: "Куда",
          value: _ctx.state.toCityId,
          "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.toCityId) = $event)),
          disabled: _ctx.disabled,
          options: _ctx.data_state.cities.list,
          loading: _ctx.data_state.cities.is_loading,
          failed: _ctx.data_state.cities.is_failed,
          "is-invalid": _ctx.validation$.toCityId.$error,
          "validation-errors": _ctx.validation$.toCityId.$errors,
          "error-text": "При получении списка городов произошла ошибка",
          "search-without-refresh": "",
          onRefresh: _ctx.loadCities
        }, null, 8, ["value", "disabled", "options", "loading", "failed", "is-invalid", "validation-errors", "onRefresh"]),
        _createVNode(_component_new_select, {
          "can-deselect": "",
          placeholder: "Тип перевозки",
          value: _ctx.state.invoiceType,
          "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.invoiceType) = $event)),
          disabled: _ctx.disabled,
          options: _ctx.INVOICE_TYPES
        }, null, 8, ["value", "disabled", "options"])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_new_button, {
          disabled: _ctx.loading || _ctx.disabled,
          class: "NewButton--reset mr-3",
          onClick: _ctx.onFiltersReset
        }, {
          default: _withCtx(() => [
            _hoisted_8,
            _createTextVNode(" Сбросить ")
          ]),
          _: 1
        }, 8, ["disabled", "onClick"]),
        _createVNode(_component_new_button, {
          disabled: _ctx.loading || _ctx.disabled,
          class: "NewButton--search",
          type: "submit"
        }, {
          default: _withCtx(() => [
            _hoisted_9,
            _createTextVNode(" Поиск ")
          ]),
          _: 1
        }, 8, ["disabled"])
      ])
    ], 32),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _createVNode(_component_radio_group, {
          options: _ctx.MONTHS,
          value: _ctx.state.monthId,
          "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.monthId) = $event)),
          onChange: _ctx.onFiltersChanged,
          class: "full-max"
        }, null, 8, ["options", "value", "onChange"]),
        (_ctx.isArchive)
          ? (_openBlock(), _createBlock(_component_radio_group, {
              key: 0,
              options: _ctx.YEARS,
              value: _ctx.state.year,
              "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.year) = $event)),
              onChange: _ctx.onFiltersChanged,
              class: "small"
            }, null, 8, ["options", "value", "onChange"]))
          : _createCommentVNode("", true)
      ])
    ])
  ], 64))
}